export interface IPaginatedResults<T> {
  records: T[];
  totalRecords: number;
  limit: number;
  offset: number;
}

export class PaginatedResults<T> implements IPaginatedResults<T> {
  records;
  totalRecords;
  limit;
  offset;

  constructor(config: IPaginatedResults<T>) {
    this.records = config.records as T[];
    this.totalRecords = config.totalRecords;
    this.limit = config.limit;
    this.offset = config.offset;
  }
}
